<template>
    <div>
        <div class="d-block note">
            <i class="rounded-circle">i</i>
            <div class="description"><slot></slot></div>
        </div>
    </div>
</template>

<script>


    export default {
        name: 'notice',
    }
</script>